var Base64 = /** @class */ (function () {
    function Base64() {
    }
    Base64.fromUint8Array = function (buf, init) {
        if (init === void 0) { init = { urlSafe: false, padding: true }; }
        var _a = init.urlSafe, urlSafe = _a === void 0 ? false : _a, _b = init.padding, padding = _b === void 0 ? true : _b;
        var paddingChar = padding ? '=' : '';
        var base64Str = '';
        var bytes = new Uint8Array(buf);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            base64Str += String.fromCharCode(bytes[i]);
        }
        base64Str = btoa(base64Str)
            .replace(/=/g, paddingChar);
        return urlSafe
            ? base64Str.replace(/\+/g, '-').replace(/\//g, '_')
                .replace(/=/g, '')
            : base64Str;
    };
    Base64.toUint8Array = function (base64String) {
        // 先移除所有的padding
        var base64StringWithoutPadding = base64String.replace(/=/g, '');
        // 重新计算padding长度
        var padding = '='.repeat((4 - (base64StringWithoutPadding.length % 4)) % 4);
        // 替换所有url-safe的字符
        var base64 = (base64StringWithoutPadding + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        var rawData = atob(base64);
        return new Uint8Array(rawData.length)
            .fill(0, 0, rawData.length)
            .map(function (_, i) { return rawData.charCodeAt(i); });
    };
    Base64.fromUTF8 = function (str, init) {
        if (init === void 0) { init = { urlSafe: false, padding: true }; }
        return Base64.fromUint8Array(UTF8.toUint8Array(str), init);
    };
    Base64.toUTF8 = function (base64String) {
        return UTF8.fromUint8Array(Base64.toUint8Array(base64String));
    };
    return Base64;
}());
var Hex = /** @class */ (function () {
    function Hex() {
    }
    Hex.encode = function (str) {
        var hexTab = '0123456789abcdef';
        var output = '';
        for (var i = 0; i < str.length; i += 1) {
            var x = str.charCodeAt(i);
            output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
        }
        return output;
    };
    Hex.toUint8Array = function (hex) {
        var result = [];
        var str = hex;
        if (!str) {
            return result;
        }
        if (str.length % 2 !== 0) {
            return result;
        }
        while (str.length >= 2) {
            result.push(parseInt(str.substring(0, 2), 16));
            str = str.substring(2, str.length);
        }
        return new Uint8Array(result);
    };
    Hex.fromUint8Array = function (buf) {
        return Array.from(new Uint8Array(buf))
            .map(function (n) { return n.toString(16).padStart(2, '0'); })
            .join('');
    };
    return Hex;
}());
var UTF16 = /** @class */ (function () {
    function UTF16() {
    }
    UTF16.toUint16Array = function (string) {
        var array = new Uint16Array(string.length);
        for (var i = 0; i < string.length; i++) {
            array[i] = string.charCodeAt(i);
        }
        return array;
    };
    UTF16.fromUint16Array = function (buf) {
        return String.fromCharCode.apply(null, new Uint16Array(buf));
    };
    UTF16.fromTypeArray = function (array) {
        return String.fromCharCode.apply(null, new Uint16Array(array.buffer));
    };
    return UTF16;
}());
var UTF8 = /** @class */ (function () {
    function UTF8() {
    }
    UTF8.toUint8Array = function (str) {
        var utf8 = [];
        for (var i = 0; i < str.length; i += 1) {
            var charCode = str.charCodeAt(i);
            if (charCode < 0x80) { // 1-byte sequence
                utf8.push(charCode);
            }
            else if (charCode < 0x800) { // 2-byte sequence
                utf8.push(0xC0 | (charCode >> 6), 0x80 | (charCode & 0x3F));
            }
            else if (charCode < 0xD800 || charCode >= 0xE000) { // 3-byte sequence
                utf8.push(0xE0 | (charCode >> 12), 0x80 | ((charCode >> 6) & 0x3F), 0x80 | (charCode & 0x3F));
            }
            else { // 4-byte sequence (surrogate pair)
                i += 1;
                charCode = 0x10000 + (((charCode & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
                utf8.push(0xF0 | (charCode >> 18), 0x80 | ((charCode >> 12) & 0x3F), 0x80 | ((charCode >> 6) & 0x3F), 0x80 | (charCode & 0x3F));
            }
        }
        return new Uint8Array(utf8);
    };
    UTF8.fromUint8Array = function (buf) {
        var bytes = new Uint8Array(buf);
        var len = bytes.byteLength;
        var result = '';
        var i = 0;
        while (i < len) {
            var firstByte = bytes[i++];
            if ((firstByte & 0x80) === 0) { // 1-byte sequence
                result += String.fromCharCode(firstByte);
            }
            else if ((firstByte & 0xE0) === 0xC0) { // 2-byte sequence
                result += String.fromCharCode(((firstByte & 0x1F) << 6) | (bytes[i++] & 0x3F));
            }
            else if ((firstByte & 0xF0) === 0xE0) { // 3-byte sequence
                result += String.fromCharCode(((firstByte & 0x0F) << 12)
                    | ((bytes[i++] & 0x3F) << 6)
                    | (bytes[i++] & 0x3F));
            }
            else { // 4-byte sequence
                var codePoint = ((firstByte & 0x07) << 18)
                    | ((bytes[i++] & 0x3F) << 12)
                    | ((bytes[i++] & 0x3F) << 6)
                    | (bytes[i++] & 0x3F);
                result += String.fromCharCode(
                // Extract the high surrogate:
                0xD800 | ((codePoint - 0x10000) >> 10), 
                // Extract the low surrogate:
                0xDC00 | ((codePoint - 0x10000) & 0x3FF));
            }
        }
        return result;
    };
    return UTF8;
}());
export default {
    base64: Base64,
    utf8: UTF8,
    utf16: UTF16,
    hex: Hex,
};
